import {useMemo} from 'react';

/**
 * A hook to extract and validate data from an array
 * @param data
 * @param selectedData
 * @param extractor
 * @param matcher
 * @param defaultSelected
 * @returns
 */
export default function useDataExtractorAndValidator<T, R>(
  data: T[],
  selectedData: R | undefined,
  extractor: (data: T) => R,
  matcher: (data: R, selectedData: R | undefined) => boolean,
  defaultSelected: R,
): {data: R[]; selected: R} {
  const extractedData = useMemo(() => data.map(extractor), [data, extractor]);
  const validatedData = useMemo(
    () => extractedData.find((d) => matcher(d, selectedData)) || defaultSelected,
    [extractedData, selectedData, matcher, defaultSelected],
  );
  return {data: extractedData, selected: validatedData};
}
